import { View } from 'foundations-components/components/View';
import PaymentMethodOnFileV2 from '../PaymentMethodOnFileV2';
import MaybeCancellationAndRefundPolicies from './MaybeCancellationAndRefundPolicies';
import TermsOfService from './TermsOfService';
import { useMerchantTermsOfServiceMessage } from '../../hooks/useMerchantTermsOfServiceMessage';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TermsOfServiceInputs = ({
  displayAcknowledgementCheckbox,
  policySettings,
  collectPaymentMethodOnFile,
  isZeroCheckout
}) => {
  const translationMessageKey = useMerchantTermsOfServiceMessage();
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "terms-of-service-inputs",
    children: [/*#__PURE__*/_jsx(HR, {}), collectPaymentMethodOnFile && /*#__PURE__*/_jsx(PaymentMethodOnFileV2, {}), displayAcknowledgementCheckbox && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TermsOfService, {
        translationMessageKey: translationMessageKey,
        isZeroCheckout: isZeroCheckout
      }), /*#__PURE__*/_jsx(MaybeCancellationAndRefundPolicies, {
        policySettings: policySettings
      })]
    })]
  });
};
export default TermsOfServiceInputs;